import '../styles/index.scss';
import '../assets/font/iconfont.css';

export default () => {};
